<div class="d-flex h-100 align-items-center">
    <div
        class="p-0 ml-2 position-relative d-flex align-items-center avatar-wrap"
        [class.avatar-wrap--open]="profileOpen"
        style="cursor: pointer;"
        placement="bottom-right"
        [ngbPopover]="popContent" popoverClass="popover--profile"
        (shown)="profileOpen = true"
        (hidden)="profileOpen = false">
        <app-avatar [user]="user" size="40" fontSize="16" [clickable]="true"></app-avatar>
        <i class="im-icon im-icon-chev-down"></i>
    </div>
</div>

<ng-template #popContent>
    <div class="head-wrap">
        <div class="icon-initial-wrap">
            <app-avatar [user]="user" size="32" fontSize="14" [typeClass]="portal"></app-avatar>
        </div>
        <div class="name-email-wrap">
            <div class="name-wrap">
                {{user.firstname}} {{user.lastname}}
            </div>
            <div class="email-wrap">
                {{user.email}}
            </div>
        </div>
    </div>
    <div class="options">
        <ul>
            <li class="d-flex">
                <a class="d-flex align-items-center" [routerLink]="['/profile']" (click)="false">
                    <span><i class="im-icon im-icon-profile-filled-2"></i></span>
                    <div class="flex-grow-1">{{'nav_admin_profile' | translate}}</div>
                </a>
            </li>
            <li class="d-flex logout" (click)="AuthenticationService.logout()">
                <a class="d-flex align-items-center">
                    <span><i class="im-icon im-icon-logout"></i></span>
                    <div class="flex-grow-1">{{'misc_logout' | translate}}</div>
                </a>
            </li>
        </ul>
    </div>
</ng-template>